<template>
  <div class="content-wrapper">
    <div class="diag-row-1" v-if="planAction.calculations">


      <ValueWithIcon
        title="Gain (kWhEF)"
        :value="parseFloat(planAction.calculations.gainConsommationEfRelatif).toLocaleString('fr')"
        unit="%"
        icon="mdi-lightning-bolt-circle"
      >
      </ValueWithIcon>

      <ValueWithIcon
        title="Gain CO2"
        :value="parseFloat(planAction.calculations.gainEmissionCo2Relatif).toLocaleString('fr')"
        unit="%"
        icon="mdi-molecule-co2"
      >
      </ValueWithIcon>

      <ValueWithIcon
        title="Gain (€TTC/an)"
        :value="parseFloat(planAction.calculations.gainCoutTtcRelatif).toLocaleString('fr')"
        unit="%"
        icon="mdi-file-document-multiple-outline"
      >
      </ValueWithIcon>

      <ValueWithIcon
        title="Investissement"
        :value="parseFloat(planAction.calculations.investissementHt).toLocaleString('fr')"
        unit="€HT"
        icon="mdi-currency-eur"
      >
      </ValueWithIcon>

      <ValueWithIcon
        title="TRI Brut"
        :value="parseFloat(planAction.calculations.tempsRetourBrut).toLocaleString('fr')"
        unit="an(s)"
        icon="mdi-clock-fast"
      >
      </ValueWithIcon>
    </div>
    <v-textarea
      v-if="planAction.description"
      :value="planAction.description"
      :key="planAction.id"
      label="Description"
      auto-grow
      filled
    ></v-textarea>
  </div>
</template>

<script>
import ValueWithIcon from '../ValueWithIcon.vue';

export default {
  components: {
    ValueWithIcon,
  },
  props: ['planAction'],
};
</script>
<style lang="scss" scoped>
  .content-wrapper{
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
  }

  .diag-row-1 {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    align-items: center;

    margin-bottom: 2rem;
  }
</style>
